import { render, staticRenderFns } from "./DetailsTraining.vue?vue&type=template&id=72da82ea&scoped=true"
import script from "./DetailsTraining.vue?vue&type=script&lang=js"
export * from "./DetailsTraining.vue?vue&type=script&lang=js"
import style0 from "./DetailsTraining.vue?vue&type=style&index=0&id=72da82ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da82ea",
  null
  
)

export default component.exports